import React, { useCallback, useRef } from "react";
import useDebouncedCallback from "../hooks/useDebouncedCallback";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

function Filter({ column }) {
  const columnFilterValue = column.getFilterValue();
  const { filterVariant, filterOptions, placeholderName, defaultValue } =
    column.columnDef.meta ?? {};

  const handleMinChange = useCallback(
    (value) => column.setFilterValue((old) => [value, old?.[1]]),
    [column]
  );

  const handleMaxChange = useCallback(
    (value) => column.setFilterValue((old) => [old?.[0], value]),
    [column]
  );

  const handleSelectChange = useCallback(
    (e) => column.setFilterValue(e.target.value),
    [column]
  );

  const handleSearchChange = useCallback(
    (value) => column.setFilterValue(value),
    [column]
  );

  return filterVariant === "range" ? (
    <div className="flex flex-1 min-w-[250px] gap-2">
      <DebouncedInput
        type="number"
        value={columnFilterValue?.[0] ?? ""}
        onChange={handleMinChange}
        placeholder="Min"
        // className="w-24 p-2 border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500"
      />
      <DebouncedInput
        type="number"
        value={columnFilterValue?.[1] ?? ""}
        onChange={handleMaxChange}
        placeholder="Max"
        // className="w-24 p-2 border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500"
      />
    </div>
  ) : filterVariant === "select" ? (
    // <select
    <select
      onChange={handleSelectChange}
      value={columnFilterValue?.toString()}
      className="flex-1 min-w-[250px] py-2 
          text-gray-800 dark:text-white 
                   bg-slate-100 dark:bg-gray-700 
                   border border-gray-300 dark:border-gray-900 
                   rounded-lg shadow-md 
                   placeholder-gray-500 dark:placeholder-slate-300 
                   focus:ring-2 focus:ring-gray-300 dark:focus:ring-slate-500"
    >
      {Object.entries(filterOptions).map(([label, value]) => (
        <option
          key={value}
          value={value}
          className="text-gray-800 dark:text-white bg-slate-100 dark:bg-gray-700 "
        >
          {label}
        </option>
      ))}
    </select>
  ) : (
    <DebouncedInput
      // className=" flex-1 min-w-[250px] p-2 bg-gray-100 border border-gray-300 rounded-lg shadow-md focus:ring-2 focus:ring-indigo-500"
      onChange={handleSearchChange}
      placeholder={placeholderName ?? "Search ..."}
      type="text"
      value={columnFilterValue ?? ""}
      debounce={300}
    />
  );
}

function DebouncedInput({
  value: initialValue,
  placeholder,
  onChange,
  debounce = 500,
  ...props
}) {
  const inputRef = useRef(null);
  const debouncedOnChange = useDebouncedCallback(onChange, debounce);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    debouncedOnChange(newValue);
    inputRef.current.value = newValue;
  };

  return (
    <div className="relative flex-1 min-w-[250px]">
      {/* Search Icon */}
      <MagnifyingGlassIcon className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-zinc-700 dark:text-white/30" />
      <input
        {...props}
        ref={inputRef}
        defaultValue={initialValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        className="pl-10 pr-3 py-2 w-full 
                   text-gray-800 dark:text-white 
                   bg-slate-100 dark:bg-gray-700 
                   border border-gray-300 dark:border-gray-900 
                   rounded-lg shadow-md 
                   placeholder-gray-500 dark:placeholder-slate-300 
                   focus:ring-2 focus:ring-gray-300 dark:focus:ring-slate-500"
      />
    </div>
  );
}

// export default DebouncedInput;

export { Filter, DebouncedInput };
